import type { IWidgetTableResult } from "app/components/widget/widget-types/TableWidget";
import React, { useContext } from "react";
import type { IWebsiteKeywordsPageFilters } from "./WebsiteKeywordsPageTypes";
import type { IChosenItem } from "../../../../../../app/@types/chosenItems";
import type { IChipItem } from "@similarweb/ui-components";

export interface IWebsiteKeywordsPageTableTopContext {
    chosenItems: IChosenItem[];
    tableFilters: IWebsiteKeywordsPageFilters;
    searchEngines: Array<{ count?: number; id: string; text: string }>;
    searchTypes: Array<{ count?: number; id: string; text: string }>;
    onOrganicPaidChange: (value) => void;
    onBrandedNonBrandedChange: (value) => void;
    onSearchChannelChange: (value: IChipItem[]) => void;
    onIntentChange: (value: IChipItem[]) => void;
    onSearchTypeChange: (value: string[]) => void;
    onSearchEngineChange: (value: string[]) => void;
    onPhraseChange: (value) => void;
    onChangeNewlyDiscovered: (value) => void;
    onChangeTrending: (value) => void;
    onChangeQuestions: (value) => void;
    onVolumeChange: (value) => void;
    setNewDifficultyRange: (value: [number, number]) => void;
    onCpcChange: (value) => void;
    onAdvancedFilterToggle: (value) => void;
    onAdvancedFilterDone: (ranges) => void;
    onAdvancedFilterClose: VoidFunction;
    onSerpFilterApply: (features) => void;
    onMultiIncludeExcludeKeywordChange: (rules) => void;
    onMultiIncludeExcludeWebsiteChange: (rules) => void;
    onChangeFilterChange: (value?: string) => void;
    isAdditionalDataLoading: boolean;
    isCompare: boolean;
    resetEnabled: boolean;
    onReset: VoidFunction;
    applyEnabled: boolean;
    onApply: VoidFunction;
    isLast28Days: boolean;
    tableData: IWidgetTableResult;
    onOpenVolume: () => void;
    onOpenCpc: () => void;
}

const WebsiteKeywordsPageTableTopContext = React.createContext<IWebsiteKeywordsPageTableTopContext>(null);
export const WebsiteKeywordsPageTableTopContextProvider = WebsiteKeywordsPageTableTopContext.Provider;
export const useWebsiteKeywordsPageTableTopContext = () =>
    useContext<IWebsiteKeywordsPageTableTopContext>(WebsiteKeywordsPageTableTopContext);
